import { getFeatureToggles } from "@/app/firebase/firebase";
import { router } from "@/app/router";
import { setIsAuth } from "@/modules/auth/state";
import { LanguageKey, Storage } from "@/shared/common/enums";
import { UserIdle } from "@/shared/components";
import { getFromLocalStorage, setToSessionStorage } from "@/shared/helpers";
import { useAnalytics, useAppDispatch } from "@/shared/hooks";
import { setFeatureToggle } from "@/shared/state/featureToggle";
import { setLanguage } from "@/shared/state/language";
import { getStaticUrls } from "@/shared/state/staticUrls";
import { Snackbar } from "@ab.uitools/ui-library/components/Snackbar";
import { detect } from "detect-browser";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { RouterProvider } from "react-router-dom";

export const App = () => {
  useAnalytics();
  const { i18n } = useTranslation();
  const browser = detect();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (browser) {
      setToSessionStorage(Storage.BrowserName, browser?.name);
      setToSessionStorage(Storage.BrowserVersion, browser?.version);
      setToSessionStorage(Storage.BrowserOs, browser?.os);
    }
  }, [browser]);

  useEffect(() => {
    const isAuth = getFromLocalStorage(Storage.IsAuth);
    dispatch(setIsAuth(!!isAuth));
  }, []);

  useEffect(() => {
    const onLangChange = (lng: string) => {
      const lang = lng.split("-")[0] as LanguageKey;
      dispatch(setLanguage(lang));
    };

    i18n.on("languageChanged", onLangChange);
    return () => i18n.off("languageChanged", onLangChange);
  }, []);

  useEffect(() => {
    const lang = getFromLocalStorage(Storage.Lang);
    const initialLang = (
      i18n.language || lang || LanguageKey.Hy
    ).split("-")[0] as LanguageKey;

    dispatch(setLanguage(initialLang));
  }, []);

  useEffect(() => {
    getFeatureToggles().then((data) => {
      dispatch(setFeatureToggle(data));
    });
    dispatch(getStaticUrls());
  }, []);

  return (
    <>
      <RouterProvider router={router}/>
      <UserIdle/>
      <Snackbar position={"bottom-center"} duration={5000}/>
    </>
  );
};
